import React, { Component } from "react";
import { connect } from "react-redux";
import TitleBar from "../../_common/TitleBar";
import ProjAdminTabs from "./ProjAdminTabs";
import ProjAdminItems from "./items/ProjAdminItems";
import ProjAdminContractors from "./contractors/ProjAdminContractors";
import ProjAdminLocations from "./locations/ProjAdminLocations";
import LaborMain from "./labor/LaborMain";
import EquipmentMain from "./equipment/EquipmentMain";
import Ccos from "./ccos/Ccos";
import projSetupTitleBarMenu from "../../_titleBarMenus/projSetupTitleBarMenu";
import KeywordsMain from "./keywords/KeywordsMain";
import { getPermissions } from "../../../_helpers/authorize";
import { DOCTYPE } from "../../../_constants/docTypeConstants";
import "./styles/projAdmin.css";
import ProjAdminCcoListV2 from "./ccos/ProjAdminCcoListV2";
import ValidateDataModal from "../../validateData/ValidateDataModal";

class ProjAdmin extends Component {
  state = {
    selectedProjSetupTabId: "",
    projSetupTabs: [
      {
        tabId: "projAdminItems",
        link: "#",
        label: "Items",
      },
      {
        tabId: "projAdminLocations",
        link: "#",
        label: "Locations",
      },
      {
        tabId: "projAdminContractors",
        link: "#",
        label: "Contractors",
      },
      {
        tabId: "projAdminLabor",
        link: "#",
        label: "Labor",
      },
      {
        tabId: "projAdminEquipment",
        link: "#",
        label: "Equipment",
      },
      {
        tabId: "projAdminCcos",
        link: "#",
        label: "COs",
      },
      // {
      //   tabId: "projSetupRfis",
      //   link: "#",
      //   label: "RFIs"
      // },
      {
        tabId: "projAdminKeywords",
        link: "#",
        label: "Keywords",
      },
    ],
    showValidateDataModal: false,
    hasPendingData: false,
  };

  componentDidMount() {
    const { user, projectId } = this.props;
    const permissions = getPermissions({
      user,
      docType: DOCTYPE.PROJECT_SETUP,
      projectId,
      creatorId: null,
    });
    this.setState({ permissions }, () =>
      this.setState({ selectedProjSetupTabId: "projAdminItems" })
    );
  }

  handleTitleBarAction = (action) => () => {
    console.log("titleBar action = ", action);
  };

  handleSelect_projSetupTab = (e) => {
    e.preventDefault();
    this.setState({ selectedProjSetupTabId: e.target.id.split("_")[0] });
  };

  handleClick_validateData = (e) => {
    e.preventDefault();
    this.toggleValidateDataModal();
  };

  toggleValidateDataModal = () => {
    this.setState({ showValidateDataModal: !this.state.showValidateDataModal });
    if (!this.state.showValidateDataModal) {
      this.getHasPendingData();
    }
  };

  getHasPendingData = async () => {
    const { dispatch, tab } = this.props;
    const hasPendingData = await dispatch(projActions.hasPendingData(tab.projectId));
    this.setState({ hasPendingData: !!hasPendingData });
  };

  getProjSetupTabContent = () => {
    const { permissions } = this.state;
    const { projectId, tabId } = this.props;
    switch (this.state.selectedProjSetupTabId) {
      case "projAdminItems":
        return (
          <div
            className="tab-pane fade show active border border-secondary"
            id="projAdminItems"
            role="tabpanel"
          >
            <ProjAdminItems
              tabId={tabId}
              projectId={projectId}
              permissions={permissions}
            />
          </div>
        );
      case "projAdminLocations":
        return (
          <div
            className="tab-pane fade show active border border-secondary"
            id="projAdminLocations"
            role="tabpanel"
          >
            <ProjAdminLocations projectId={projectId} permissions={permissions} />
          </div>
        );
      case "projAdminContractors":
        return (
          <div
            className="tab-pane fade show active border border-secondary"
            id="projAdminContractors"
            role="tabpanel"
          >
            <ProjAdminContractors
              tabId={tabId}
              projectId={projectId}
              permissions={permissions}
            />
          </div>
        );
      case "projAdminLabor":
        return (
          <div
            className="tab-pane fade show active border border-secondary"
            id="projAdminLabor"
            role="tabpanel"
          >
            <LaborMain tabId={tabId} projectId={projectId} permissions={permissions} />
          </div>
        );
      case "projAdminEquipment":
        return (
          <div
            className="tab-pane fade show active border border-secondary"
            id="projAdminEquipment"
            role="tabpanel"
          >
            <EquipmentMain projectId={projectId} permissions={permissions} />
          </div>
        );
      case "projAdminCcos":
        return (
          <div
            className="tab-pane fade show active border border-secondary"
            id="projAdminCcos"
            role="tabpanel"
          >
            <ProjAdminCcoListV2 projectId={projectId} permissions={permissions} />
          </div>
        );
      case "projAdminKeywords":
        return (
          <div
            className="tab-pane fade show active border border-secondary"
            id="projAdminKeywords"
            role="tabpanel"
          >
            <KeywordsMain projectId={projectId} permissions={permissions} />
          </div>
        );
      default:
        return;
    }
  };

  render() {
    const {
      projSetupTabs,
      selectedProjSetupTabId,
      showValidateDataModal,
      permissions,
      hasPendingData,
    } = this.state;
    const { projectId } = this.props;
    return (
      <React.Fragment>
        <TitleBar
          titleText={"Project Administration"}
          menu={projSetupTitleBarMenu}
          handleTitleBarAction={this.handleTitleBarAction}
        />
        {/* Legacy validate button - validation moved to native app prior to upload.
        <div className="card mx-2 mb-3">
          <div className="card-body p-2">
            {hasPendingData && permissions.includes(docPermConstants.VALIDATE) && (
              <div className="form-inline form-row flex-grow-1">
                <label htmlFor="includeFrom" className="col-form-label text-danger">
                  <b>You have data to review</b>
                </label>
                <div className="mr-2">
                  <button
                    type="button"
                    name="validateData"
                    id="validateData"
                    className={"btn btn-danger"}
                    onClick={this.handleClick_validateData}
                  >
                    Validate Data
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
        */}
        <div className="row mx-0">
          <div className="col-12 px-2">
            <ProjAdminTabs
              tabs={projSetupTabs}
              onProjSetupTabSelect={this.handleSelect_projSetupTab}
              selectedProjSetupTabId={selectedProjSetupTabId}
            />
            <div className="tab-content mx-0">{this.getProjSetupTabContent()}</div>
          </div>
        </div>
        {showValidateDataModal && (
          <ValidateDataModal
            showValidateDataModal={showValidateDataModal}
            toggleValidateDataModal={this.toggleValidateDataModal}
            projectId={projectId}
          />
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.authentication.user,
});
export default connect(mapStateToProps)(ProjAdmin);
